import React from "react";
import { Button, Form, FormMessage } from "lib/index";

import CSSModules from "lib/utils/css-modules";
import styles from "./CalendarForm.less";
import * as FormControl from "../../../lib/components/FormControl";
import TotalStockLeftField from "../TotalStockLeftField";
import { availabilityTypesOptions } from "../common";

@CSSModules(styles)
export default class CalendarForm extends React.PureComponent {
  componentWillUnmount() {
    const nextData = Object.keys(this.props.data).reduce((obj, key) => {
      obj[key] = null;
      return obj;
    }, {});
    this.props.onChange(nextData);
  }

  handleChange(key, value) {
    const nextData = {
      ...this.props.data,
      [key]: value,
    };
    this.props.onChange(nextData);
  }

  handlePriceChange(price) {
    this.handleChange("price", price ? price.value : null);
  }

  handleMinNightStayChange(value) {
    if (value === null || value === "") {
      this.handleChange("minNightStay", null);
      return;
    }
    const clamped = Math.max(1, Math.min(31, Math.round(value)));
    this.handleChange("minNightStay", clamped);
  }

  render() {
    const { data, currency, showAvailability, showPrice, onSubmit, loading, responseError } = this.props;

    return (
      <div styleName="calendar-form">
        <Form onSubmit={onSubmit}>
          {showPrice && (
            <FormControl.MoneyFormGroup
              value={{ value: data.price, currency }}
              onChange={this.handlePriceChange.bind(this)}
              currencyEditable={false}
              defaultCurrency={currency}
              label="Cena za pokój / jednostkę noclegową"
              inlineLabel
              disabled={loading}
            />
          )}
          {showAvailability && (
            <TotalStockLeftField
              value={data.totalStockLeft}
              onChange={this.handleChange.bind(this, "totalStockLeft")}
            />
          )}
          {showAvailability && (
            <FormControl.SelectFormGroup
              value={data.availabilityType}
              onChange={this.handleChange.bind(this, "availabilityType")}
              label={I18n.t("papp.accommodation.AccommodationSchedulerView.availabilityTypeHeader")}
              options={availabilityTypesOptions}
              className="u-largeWidth availability-type"
              placeholder={I18n.t(`papp.accommodation.AccommodationSchedulerView.availabilityTypes.no_changes`)}
              includeBlank
              inlineLabel
              disabled={loading}
            />
          )}
          {showAvailability && (
            <FormControl.InputFormGroup
              value={data.minNightStay}
              onChange={this.handleMinNightStayChange.bind(this)}
              type="number"
              min={1}
              max={31}
              label={I18n.t("attributes.min_nights_count")}
              className="u-largeWidth"
              inlineLabel
              disabled={loading}
            />
          )}
          <div className="button-field">
            <Button
              type="submit"
              primary
              content={I18n.t("papp.common.save")}
              disabled={loading || Object.values(data).every((v) => v === null)}
            />
          </div>
        </Form>
        {responseError && <FormMessage error={responseError} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/accommodation/AccommodationCalendarView/CalendarForm.jsx